import { useState } from "react";
import ApiFetch from "../../services/api.fetch";
import { URLS } from "../../utils/url";

export enum MediaSource {
  IMAGES = 0,
  ADDITIONALFILES = 1,
}

export const useFiles = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState({
    message: "",
    status: false,
  });

  const getPropertyImages = async (propertyId: any) => {
    const property = await ApiFetch.httpGet(
      URLS.get.property.getPropertyById.id(propertyId)
    );
    const fileIds = property.propertyMedia?.propertyImages?.map((x: any) => {
      return x.fileId;
    });
    const result = await ApiFetch.httpPost(
      URLS.post.file.propertyImageUrls,
      fileIds
    );
    const sortedFiles = result.sort(
      (a: any, b: any) => a.imageOrderPosition - b.imageOrderPosition
    );
    return sortedFiles;
  };

  const getDownloadLinks = async (fileIds: any[]) => {
    const result = await ApiFetch.httpPost(
      URLS.post.file.downloadUrls,
      fileIds
    );
    return result;
  };

  const uploadFiles = async (
    userId: number,
    candidateScreeningId: number,
    files: any
  ) => {
    const payload = files.map((file: any) => {
      return {
        fileName: file.name,
        fileType: "DOCUMENT",
        documentType: file.id,
      };
    });
    try {
      setLoading(true);
      const data = await ApiFetch.httpPost(
        URLS.post.file.prepare.params(
          userId,
          candidateScreeningId,
          "PRIVATE_FILE"
        ),
        payload
      );

      const uploadPromises = data.map(async (element: any, index: any) => {
        const blob = await getBlob(files[index]);
        return await uploadFile(element.presignedUrl, blob);
      });

      await Promise.all(uploadPromises);
      return data;
    } catch (err) {
      console.log(err, "ERROR");
      setError({
        status: true,
        message: "Something went wrong",
      });
      throw new Error(error.message);
    } finally {
      setLoading(false);
    }
  };

  const getBlob = async (file: File) => {
    return file;
  };

  const uploadFile = async (endpoint: string, file: any) => {
    try {
      const result = await ApiFetch.httpPutExternalFile(endpoint, file);
      return result;
    } catch (err) {
      console.log(err);
      setError({
        status: true,
        message: "Something went wrong",
      });
      throw new Error(error.message);
    }
  };

  return {
    getPropertyImages,
    uploadFiles,
    getDownloadLinks,
    loading,
    error,
  };
};
